<template>
  <div class="flex flex-col h-full px-4">
    <Textarea v-model="adminNote" rows="5" cols="30" placeholder="מה תרצו לכתוב על התור?" />
    <drawer-footer
      class="mt-auto"
      approve-label="הוספת הערה"
      @approve-click="addNote"
      @cancel-click="onClose"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  onNodeAdded: (text: string) => void;
  onClose: () => void;
}>();

const adminNote = ref<string>();

const addNote = () => {
  props.onNodeAdded(adminNote.value ?? '');
  props.onClose();
};
</script>
